var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreateOrderTransferPromo',{attrs:{"office-type":"member","use-origin-warehouse":"","index-route":{ name: 'penjualan.kirim-barang-promo.ke-mitra' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }